import { LockIcon } from '@/components/ui/icons'

export function NavLockIcon() {
  return <LockIcon className="ml-1.5 h-4 w-4 shrink-0 text-subtle" data-testid="lock-icon" />
}
